module.exports = __webpack_public_path__ + "static/404.8770243d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/404.png
// module id = 894
// module chunks = 183328146348521